/**
 * PROTOTYPE Material Traceability add-ons -- THROWAWAY.
 *
 * MT-only flat add-on toggles (gas / wire / coating-materials tracking). The data-source
 * (mill) model is shared across modules and lives in spreadSourceData.
 */

export type MtAddOn = 'gas' | 'wire' | 'coatingMaterials';
export interface MtOptions { gas: boolean; wire: boolean; coatingMaterials: boolean; }
export const MT_ADDONS: { key: MtAddOn; label: string }[] = [
  { key: 'gas', label: 'Gas tracking' },
  { key: 'wire', label: 'Wire tracking' },
  { key: 'coatingMaterials', label: 'Coating-materials tracking' },
];
export const DEFAULT_MT_OPTIONS: MtOptions = { gas: false, wire: false, coatingMaterials: false };
